import _extends from "@babel/runtime/helpers/esm/extends";
export const getPickersLocalization = pickersTranslations => {
  return {
    components: {
      MuiLocalizationProvider: {
        defaultProps: {
          localeText: _extends({}, pickersTranslations)
        }
      }
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/x-date-pickers/locales/utils/getPickersLocalization.js
// module id = 56
// module chunks = 0